import { twMerge } from 'tailwind-merge';
import { ColumnDef, RowDef } from '../../types';
import { Ref } from 'react';

type RowProps<T> = {
  row: RowDef<T>;
  columns: ColumnDef<T>[];
  lastRowRef?: Ref<HTMLTableRowElement>;
};

export const TableRow = <T,>({ row, columns, lastRowRef }: RowProps<T>) => {
  return (
    <tr
      ref={lastRowRef}
      onClick={row.onClick}
      className={twMerge(!!row.onClick && 'cursor-pointer')}
    >
      {columns.map((column) => (
        <td
          key={`${column.id}_${row.id}`}
          align={column.alignment ?? 'center'}
          className={twMerge(
            'group/cell m-0 border-collapse border-spacing-0 border-b-4 border-transparent p-0',
            column.tdClassNames,
          )}
        >
          <div
            className={twMerge(
              'text-primaryBlue flex h-11 items-center justify-center overflow-hidden overflow-ellipsis bg-white p-2.5 text-sm text-gray',
              `border-b border-t border-gray-200 group-first/cell:rounded-l-md group-first/cell:border-l group-last/cell:rounded-r-md group-last/cell:border-r group-last/cell:border-t`,
              column.alignment === 'left' && 'justify-start',
              column.alignment === 'right' && 'justify-end',
              column.rowContainerClassNames,
            )}
          >
            {column.renderRow?.(row) ??
              (column.accessor && (
                <span className="w-full overflow-hidden text-ellipsis text-nowrap">
                  {`${row[column.accessor]}`}
                </span>
              ))}
          </div>
        </td>
      ))}
    </tr>
  );
};
